(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colon-final"] && !Shopify.designMode) return;
  try {
    
  // Selbstheilung für den Cart-Drawer — gleicher Code wie in colon-pricing.liquid,
  // Guard verhindert doppelte Registrierung, wenn beide Sections auf der Seite sind.
  if (!window.__colonCartDrawerFix) {
    window.__colonCartDrawerFix = true;
    document.addEventListener('cart:change', function (event) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      var sectionEl = drawer.closest('.shopify-section');
      if (!sectionEl) return;
      var sectionId = sectionEl.id.replace('shopify-section-', '');
      var sections = event.detail && event.detail.cart && event.detail.cart.sections;
      if (!sections || !sections[sectionId]) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colon-pricing"] && !Shopify.designMode) return;
  try {
    
  // Selbstheilung für den Cart-Drawer (Add-to-Cart über colon-atc): Shopify lässt bei
  // /cart/add.js den "sections"-Key gelegentlich weg (z. B. Rendering-Timeout). Das
  // Theme-JS greift ungeprüft auf cart.sections[drawerId] zu und bricht ab — der Drawer
  // öffnet sich leer. Fehlt das Drawer-HTML im cart:change-Event, holen wir den Drawer
  // über das theme-eigene cart:refresh komplett frisch vom Server.
  if (!window.__colonCartDrawerFix) {
    window.__colonCartDrawerFix = true;
    document.addEventListener('cart:change', function (event) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      var sectionEl = drawer.closest('.shopify-section');
      if (!sectionEl) return;
      var sectionId = sectionEl.id.replace('shopify-section-', '');
      var sections = event.detail && event.detail.cart && event.detail.cart.sections;
      if (!sections || !sections[sectionId]) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
